module.exports = __webpack_public_path__ + "static/step-4-95e83fb47fc541c3d95ab44ef32fde58.svg";